import { useState, useRef, useCallback, useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { ChevronLeft, Upload, CheckCircle, XCircle, Clock, RefreshCw } from 'lucide-react'
import { useAppStore } from '../store/useAppStore'
import { api } from '../lib/api'
import QRCode from 'qrcode'

const T = {
  transferAmount: '\u0E42\u0E2D\u0E19\u0E40\u0E07\u0E34\u0E19',
  scanQR:         '\u0E2A\u0E41\u0E01\u0E19 QR \u0E41\u0E25\u0E49\u0E27\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E25\u0E34\u0E1B',
  refCode:        '\u0E23\u0E2B\u0E31\u0E2A\u0E2D\u0E49\u0E32\u0E07\u0E2D\u0E34\u0E07',
  accountName:    '\u0E0A\u0E37\u0E48\u0E2D\u0E1A\u0E31\u0E0D\u0E0A\u0E35',
  accountOwner:   '\u0E19\u0E31\u0E19\u0E17\u0E1E\u0E25 \u0E27\u0E07\u0E29\u0E4C\u0E1E\u0E23\u0E2B\u0E21',
  bank:           '\u0E18\u0E19\u0E32\u0E04\u0E32\u0E23',
  expiresIn:      '\u0E2B\u0E21\u0E14\u0E2D\u0E32\u0E22\u0E38\u0E43\u0E19',
  expired:        '\u0E2B\u0E21\u0E14\u0E40\u0E27\u0E25\u0E32',
  putRefIn:       '\u0E43\u0E2A\u0E48',
  inNoteField:    '\u0E43\u0E19\u0E0A\u0E48\u0E2D\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E2B\u0E15\u0E38',
  uploadSlip:     '\u0E2D\u0E31\u0E1B\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E25\u0E34\u0E1B',
  payment:        '\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19',
  checking:       '\u0E01\u0E33\u0E25\u0E31\u0E07\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E2A\u0E25\u0E34\u0E1B',
  pleaseWait:     '\u0E01\u0E23\u0E38\u0E13\u0E32\u0E23\u0E2D\u0E2A\u0E31\u0E01\u0E04\u0E23\u0E39\u0E48...',
  reviewing:      '\u0E2D\u0E22\u0E39\u0E48\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A',
  reviewDesc:     '\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E23\u0E30\u0E1A\u0E1A\u0E01\u0E33\u0E25\u0E31\u0E07\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A \u0E1B\u0E01\u0E15\u0E34\u0E43\u0E0A\u0E49\u0E40\u0E27\u0E25\u0E32\u0E44\u0E21\u0E48\u0E40\u0E01\u0E34\u0E19 10 \u0E19\u0E32\u0E17\u0E35',
  willNotify:     '\u0E23\u0E30\u0E1A\u0E1A\u0E08\u0E30\u0E41\u0E08\u0E49\u0E07\u0E43\u0E2B\u0E49\u0E17\u0E23\u0E32\u0E1A\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E40\u0E2A\u0E23\u0E47\u0E08',
  back:           '\u0E22\u0E49\u0E2D\u0E19\u0E01\u0E25\u0E31\u0E1A',
  approved:       '\u0E1B\u0E25\u0E14\u0E25\u0E47\u0E2D\u0E01\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08!',
  approvedDesc:   '\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E15\u0E31\u0E4B\u0E27\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27',
  done:           '\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E34\u0E49\u0E19',
  rejected:       '\u0E2A\u0E25\u0E34\u0E1B\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07',
  rejectedDesc:   '\u0E2B\u0E32\u0E01\u0E17\u0E48\u0E32\u0E19\u0E44\u0E14\u0E49\u0E42\u0E2D\u0E19\u0E40\u0E07\u0E34\u0E19\u0E08\u0E23\u0E34\u0E07 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D Admin',
  retry:          '\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48',
  errorMsg:       '\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14',
}

const BAHT = '\u0E3F'

type PaymentStep = 'init' | 'qr' | 'uploading' | 'pending_review' | 'approved' | 'rejected' | 'expired'

interface PaymentState {
  step: PaymentStep
  refCode: string | null
  qrDataUrl: string | null
  amount: number
  expiresAt: string | null
}

const PENDING_KEY = 'amulet_pending_payment'

function savePending(refCode: string, status: 'awaiting_slip' | 'pending_review' | 'completed' | 'rejected' | 'expired') {
  localStorage.setItem(PENDING_KEY, JSON.stringify({ ref_code: refCode, status }))
}

function clearPending() { localStorage.removeItem(PENDING_KEY) }

async function makeQrDataUrl(qrPayload: string): Promise<string> {
  return QRCode.toDataURL(qrPayload, {
    width: 280, margin: 2, color: { dark: '#000000', light: '#ffffff' },
  })
}

function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve((reader.result as string).split(',')[1])
    reader.onerror = reject
    reader.readAsDataURL(file)
  })
}

function useCountdown(expiresAt: string | null): { mm: string; ss: string; expired: boolean } {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    if (!expiresAt) return
    const id = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(id)
  }, [expiresAt])

  if (!expiresAt) return { mm: '00', ss: '00', expired: false }
  const remaining = Math.max(0, new Date(expiresAt).getTime() - now)
  const totalSec = Math.floor(remaining / 1000)
  const mm = String(Math.floor(totalSec / 60)).padStart(2, '0')
  const ss = String(totalSec % 60).padStart(2, '0')
  return { mm, ss, expired: remaining === 0 }
}

function StepQR({ state, onUpload }: { state: PaymentState; onUpload: (file: File) => void }) {
  const fileRef = useRef<HTMLInputElement>(null)
  const { mm, ss, expired } = useCountdown(state.expiresAt)
  const isWarning = mm === '00' || (mm.length === 2 && parseInt(mm) < 5)

  return (
    <div className="flex flex-col items-center gap-5 pb-6">
      <div className="text-center">
        <h2 className="text-xl font-bold" style={{ color: 'var(--color-text)' }}>{T.transferAmount} {state.amount}{BAHT}</h2>
        <p className="text-sm mt-1" style={{ color: 'var(--color-text-muted)' }}>{T.scanQR}</p>
      </div>
      {state.qrDataUrl && (
        <div className="p-4 rounded-2xl bg-white shadow-lg">
          <img src={state.qrDataUrl} alt="PromptPay QR" className="w-56 h-56" />
        </div>
      )}
      <div className="w-full p-4 rounded-2xl space-y-2 card-amulet">
        <div className="flex justify-between text-sm">
          <span style={{ color: 'var(--color-text-muted)' }}>{T.refCode}</span>
          <span className="font-mono font-bold" style={{ color: 'var(--color-gold)' }}>{state.refCode}</span>
        </div>
        <div className="flex justify-between text-sm">
          <span style={{ color: 'var(--color-text-muted)' }}>{T.accountName}</span>
          <span style={{ color: 'var(--color-text)' }}>{T.accountOwner}</span>
        </div>
        <div className="flex justify-between text-sm">
          <span style={{ color: 'var(--color-text-muted)' }}>{T.bank}</span>
          <span style={{ color: 'var(--color-text)' }}>Bangkok Bank</span>
        </div>
        <div className="flex justify-between text-sm">
          <span style={{ color: 'var(--color-text-muted)' }}>{T.expiresIn}</span>
          <span className="font-mono font-bold tabular-nums"
                style={{ color: expired ? 'var(--color-danger)' : isWarning ? 'var(--color-danger)' : 'var(--color-text)' }}>
            {expired ? T.expired : `${mm}:${ss}`}
          </span>
        </div>
      </div>
      <p className="text-xs text-center px-4" style={{ color: 'var(--color-text-muted)' }}>
        {T.putRefIn} <strong style={{ color: 'var(--color-gold)' }}>{state.refCode}</strong> {T.inNoteField}
      </p>
      <input ref={fileRef} type="file" accept="image/*"
             className="hidden" onChange={e => { const f = e.target.files?.[0]; if (f) onUpload(f) }} />
      <button onClick={() => fileRef.current?.click()} disabled={expired}
              className="w-full py-4 rounded-2xl font-semibold flex items-center justify-center gap-2 disabled:opacity-50 btn-gold shimmer">
        <Upload size={20} /> {T.uploadSlip}
      </button>
    </div>
  )
}

export default function PaymentPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { lineUid } = useAppStore()
  const queryClient = useQueryClient()

  const amount = parseInt(searchParams.get('amount') ?? '9')
  const guruId = searchParams.get('guru_id') ?? 'guru_default'
  const drawId = searchParams.get('draw_id') ?? 'current'

  const [state, setState] = useState<PaymentState>({
    step: 'init', refCode: null, qrDataUrl: null, amount, expiresAt: null,
  })
  const [initError, setInitError] = useState<string | null>(null)
  const initialized = useRef(false)

  const initPayment = useCallback(async () => {
    if (!lineUid || initialized.current) return
    initialized.current = true
    try {
      const res = await api.payment.init(lineUid, amount, {
        type: amount >= 19 ? 'combo' : 'guru',
        guru_id: guruId,
        draw_id: drawId,
      }) as { ref_code: string; qr_payload: string; expires_at: string }
      const qrDataUrl = await makeQrDataUrl(res.qr_payload)
      savePending(res.ref_code, 'awaiting_slip')
      setState(s => ({ ...s, step: 'qr', refCode: res.ref_code, qrDataUrl, expiresAt: res.expires_at }))
    } catch (err) {
      setInitError(err instanceof Error ? err.message : T.errorMsg)
    }
  }, [lineUid, amount, guruId, drawId])

  useEffect(() => { initPayment() }, [initPayment])

  async function handleSlipUpload(file: File) {
    setState(s => ({ ...s, step: 'uploading' }))
    try {
      const base64 = await fileToBase64(file)
      const res = await api.payment.uploadSlip(state.refCode!, lineUid!, base64) as { status: string }
      if (res.status === 'approved') {
        savePending(state.refCode!, 'completed')
        // Sync ตั๋วทุกหน้าหลังจ่ายเงินสำเร็จ
        queryClient.invalidateQueries({ queryKey: ['user', 'profile', lineUid] })
        queryClient.invalidateQueries({ queryKey: ['user', 'stats', lineUid] })
        queryClient.invalidateQueries({ queryKey: ['horoscope', 'today', lineUid] })
        setState(s => ({ ...s, step: 'approved' }))
      } else if (res.status === 'pending_review') {
        savePending(state.refCode!, 'pending_review')
        setState(s => ({ ...s, step: 'pending_review' }))
      } else {
        savePending(state.refCode!, 'rejected')
        setState(s => ({ ...s, step: 'rejected' }))
      }
    } catch {
      setState(s => ({ ...s, step: 'rejected' }))
    }
  }

  function handleRetry() {
    initialized.current = false
    clearPending()
    setState(s => ({ ...s, step: 'init', refCode: null, qrDataUrl: null }))
    initPayment()
  }

  function backToPrev() { navigate(-1) }

  if (initError) {
    return (
      <div className="flex flex-col items-center justify-center min-h-dvh gap-4 p-6 text-center"
           style={{ background: 'var(--color-bg)' }}>
        <div className="text-4xl">{'\u26A0\uFE0F'}</div>
        <p style={{ color: 'var(--color-danger)' }}>{initError}</p>
        <button onClick={() => navigate(-1)} className="px-6 py-3 rounded-xl"
                style={{ background: 'var(--color-surface)', color: 'var(--color-text)' }}>{T.back}</button>
      </div>
    )
  }

  if (state.step === 'init') {
    return (
      <div className="flex items-center justify-center min-h-dvh" style={{ background: 'var(--color-bg)' }}>
        <div className="text-4xl animate-pulse">{'\u{1F4B3}'}</div>
      </div>
    )
  }

  return (
    <div className="flex flex-col min-h-dvh p-4" style={{ background: 'var(--color-bg)' }}>
      {state.step === 'qr' && (
        <div className="flex items-center gap-3 mb-6">
          <button onClick={() => navigate(-1)} style={{ color: 'var(--color-text-muted)' }}>
            <ChevronLeft size={24} />
          </button>
          <h1 className="text-lg font-bold" style={{ color: 'var(--color-text)' }}>{T.payment}</h1>
        </div>
      )}

      {state.step === 'qr' && <StepQR state={state} onUpload={handleSlipUpload} />}

      {state.step === 'uploading' && (
        <div className="flex flex-col items-center gap-4 py-12 flex-1 justify-center">
          <div className="text-5xl animate-pulse">{'\u{1F50D}'}</div>
          <h2 className="text-xl font-semibold" style={{ color: 'var(--color-text)' }}>{T.checking}</h2>
          <p className="text-sm text-center" style={{ color: 'var(--color-text-muted)' }}>{T.pleaseWait}</p>
          <div className="flex gap-1 mt-4">
            {[0, 1, 2].map(i => (
              <div key={i} className="w-2 h-2 rounded-full animate-bounce"
                   style={{ background: 'var(--color-primary)', animationDelay: `${i * 0.15}s` }} />
            ))}
          </div>
        </div>
      )}

      {state.step === 'pending_review' && (
        <div className="flex flex-col items-center gap-4 py-12 flex-1">
          <Clock size={56} style={{ color: 'var(--color-gold)' }} />
          <h2 className="text-xl font-semibold" style={{ color: 'var(--color-text)' }}>{T.reviewing}</h2>
          <p className="text-sm text-center px-4" style={{ color: 'var(--color-text-muted)' }}>
            {T.reviewDesc}<br/>{T.willNotify}
          </p>
          <p className="text-xs" style={{ color: 'var(--color-text-muted)' }}>
            {T.refCode}: <span className="font-mono" style={{ color: 'var(--color-gold)' }}>{state.refCode}</span>
          </p>
          <button onClick={backToPrev}
                  className="mt-4 px-8 py-3 rounded-2xl font-semibold"
                  style={{ background: 'var(--color-surface)', color: 'var(--color-text)' }}>
            {T.back}
          </button>
        </div>
      )}

      {state.step === 'approved' && (
        <div className="flex flex-col items-center gap-4 py-12 flex-1">
          <CheckCircle size={64} style={{ color: 'var(--color-success)' }} />
          <h2 className="text-xl font-semibold" style={{ color: 'var(--color-success)' }}>{T.approved}</h2>
          <p className="text-sm text-center" style={{ color: 'var(--color-text-muted)' }}>{T.approvedDesc}</p>
          <button onClick={() => { clearPending(); navigate(-1) }}
                  className="mt-4 px-8 py-3 rounded-2xl font-semibold btn-gold shimmer">
            {T.done}
          </button>
        </div>
      )}

      {state.step === 'rejected' && (
        <div className="flex flex-col items-center gap-4 py-12 flex-1">
          <XCircle size={64} style={{ color: 'var(--color-danger)' }} />
          <h2 className="text-xl font-semibold" style={{ color: 'var(--color-danger)' }}>{T.rejected}</h2>
          <p className="text-sm text-center px-4" style={{ color: 'var(--color-text-muted)' }}>{T.rejectedDesc}</p>
          <div className="flex gap-3 mt-4">
            <button onClick={handleRetry}
                    className="px-6 py-3 rounded-2xl font-semibold flex items-center gap-2"
                    style={{ background: 'var(--color-primary)', color: '#fff' }}>
              <RefreshCw size={16} /> {T.retry}
            </button>
            <button onClick={() => { clearPending(); navigate(-1) }}
                    className="px-6 py-3 rounded-2xl font-semibold"
                    style={{ background: 'var(--color-surface)', color: 'var(--color-text)' }}>
              {T.back}
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
